import {
    IFetchResponse,
    fetchDeleteUtility,
    fetchGetUtility,
    fetchPostFileUtility,
    fetchPostUtility,
    fetchPutUtility,
} from '@/utilities/fetch';
import IDeal from './IDeal';
import IDealProperty from './IDealProperty';
import {
    transformDeal,
    transformProperty,
} from './transformers';

export async function dealAddRequest(deal: IDeal): Promise<IFetchResponse> {
    return fetchPostUtility('/deals', transformDeal(deal));
}

export async function dealCompleteRequest(deal: IDeal, autoQuote: boolean): Promise<IFetchResponse> {
    return fetchPostUtility(`/deals/${deal.uuid}/complete`, {
        autoQuote,
    });
}

export async function dealFileAddRequest(deal: IDeal, file: File): Promise<IFetchResponse> {
    return fetchPostFileUtility(`/deals/${deal.uuid}/documents`, file);
}

export async function dealGetRequest(dealUuid: string): Promise<IFetchResponse> {
    return fetchGetUtility(`/deals/${dealUuid}`);
}

export async function dealUpdateRequest(deal: IDeal): Promise<IFetchResponse> {
    return fetchPutUtility(`/deals/${deal.uuid}`, transformDeal(deal));
}

export async function dealReferredByRequest(dealUuid: string, token: string): Promise<IFetchResponse> {
    return fetchPostUtility(`/deals/${dealUuid}/referred-by`, {
        token,
    });
}

export async function dealPropertiesAddRequest(deal: IDeal, property: IDealProperty): Promise<IFetchResponse> {
    return fetchPostUtility(`/deals/${deal.uuid}/properties`, transformProperty(property));
}

export async function dealPropertyDeleteRequest(propertyUuid: string): Promise<IFetchResponse> {
    return fetchDeleteUtility(`/deal-properties/${propertyUuid}`);
}

export async function dealPropertyUpdateRequest(property: IDealProperty): Promise<IFetchResponse> {
    return fetchPutUtility(`/deal-properties/${property.uuid}`, transformProperty(property));
}

export async function dealPropertyGnafAddressDetailRequest(propertyUuid: string, gnafAddressDetailPid: string): Promise<IFetchResponse> {
    return fetchPostUtility(`/deal-properties/${propertyUuid}/gnaf-address-detail`, { gnafAddressDetailPid });
}

export async function dealQuotesListRequest(dealUuid: string): Promise<IFetchResponse> {
    return fetchGetUtility(`/deals/${dealUuid}/quotes`);
}

export async function dealsListRequest(): Promise<IFetchResponse> {
    return fetchGetUtility('/deals');
}
